export default __webpack_public_path__ + "static/media/team2.c43e6b59.jpg";